import { KeyDict } from '@/types'

export class VolumeInterpolation {
  speed: number // "Units of volume" to change per second.
  volumeTargets: KeyDict<{current: number, target: number, lastUpdate: number}>

  constructor (speed: number = 1.0) {
    this.speed = speed
    this.volumeTargets = {}
  }

  clearVolume (streamId: string): void {
    delete this.volumeTargets[streamId]
  }

  clearAll (): void {
    this.volumeTargets = {}
  }

  // TOASK: Should the volume change always start from zero initially? Or should
  // the current stream volumes be used in case this is the first volume request
  // for that stream?
  getVolume (stream: {id: string, volume: number}): number {
    const volume = stream.volume

    const currentTime = Date.now()
    if (this.volumeTargets[stream.id] === undefined) {
      this.volumeTargets[stream.id] = {
        current: 0,
        target: volume,
        lastUpdate: currentTime
      }
    } else {
      // Note: Update the current volume before setting a potentially new target.
      // Otherwise if the time difference is large, the volume would jump directly
      // to the new target, instead of starting interpolation from the previous
      // target.
      this.updateVolumes(stream.id, currentTime)
      this.volumeTargets[stream.id].target = volume
    }

    return this.volumeTargets[stream.id].current
  }

  updateVolumes (id: string, currentTime: number = Date.now()): void {
    const volumeTarget = this.volumeTargets[id]

    const dT = currentTime - volumeTarget.lastUpdate
    if (dT <= 0) return
    const volumeChange = (dT / 1000) * this.speed

    const tgtVol = volumeTarget.target
    let curVol = volumeTarget.current
    if ( curVol < tgtVol ) {
      curVol = Math.min(curVol + volumeChange, tgtVol)
    } else if (curVol > tgtVol) {
      curVol = Math.max(curVol - volumeChange, tgtVol)
    }

    volumeTarget.current = curVol
    volumeTarget.lastUpdate = currentTime
  }
}
